import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { InViewportDirective } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { SdBannerContentModule } from '../banner-content';
import { SdSimpleResponsiveBannerComponent } from './simple-responsive-banner.component';

@NgModule({
  declarations: [SdSimpleResponsiveBannerComponent],
  imports: [
    NgIf,
    AsyncPipe,
    GenericLinkComponent,
    SdBannerContentModule,
    InViewportDirective,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.SimpleResponsiveBannerComponent]: {
          component: SdSimpleResponsiveBannerComponent,
        },
      },
    }),
  ],
})
export class SdSimpleResponsiveBannerModule {}
